import { render, staticRenderFns } from "./ShippingRecord.vue?vue&type=template&id=64767cba&scoped=true"
import script from "./ShippingRecord.vue?vue&type=script&lang=ts"
export * from "./ShippingRecord.vue?vue&type=script&lang=ts"
import style0 from "./ShippingRecord.vue?vue&type=style&index=0&id=64767cba&prod&scoped=true&lang=scss"
import style1 from "./ShippingRecord.vue?vue&type=style&index=1&id=64767cba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64767cba",
  null
  
)

export default component.exports